import { render, staticRenderFns } from "./ui-plan-limits.vue?vue&type=template&id=013275bb&scoped=true&"
import script from "./ui-plan-limits.vue?vue&type=script&lang=ts&"
export * from "./ui-plan-limits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013275bb",
  null
  
)

export default component.exports